import type { ReactNode } from "react";
import { useTranslate } from "ra-core";
import { useIsMobile } from "@/hooks/use-mobile";

import MobileHeader from "../layout/MobileHeader";
import { MobileContent } from "../layout/MobileContent";

/** On a phone, put iTHNK pages under the fixed mobile header like the other mobile screens */
export const IthnkPage = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  const isMobile = useIsMobile();
  const translate = useTranslate();
  if (!isMobile) return children;
  return (
    <>
      <MobileHeader showRefresh>
        <h1 className="text-xl font-semibold">
          {translate(title, { smart_count: 2 })}
        </h1>
      </MobileHeader>
      <MobileContent>{children}</MobileContent>
    </>
  );
};
